// extracted by mini-css-extract-plugin
export default {"container":"ConfirmModal_container__ydK38"};